var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLaptopIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_318_1668)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.22461 43.8424C1.22461 42.9941 1.98864 42.3063 2.93112 42.3063H48.4381C49.3805 42.3063 50.1446 42.9941 50.1446 43.8424C50.1446 44.6908 49.3805 45.3786 48.4381 45.3786H2.93112C1.98864 45.3786 1.22461 44.6908 1.22461 43.8424Z",
    fill: "url(#paint0_linear_318_1668)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.20577 10.7958C5.20647 12.5955 5.20647 15.4921 5.20647 21.2853V31.5263C5.20647 35.3884 5.20647 37.3195 6.53933 38.5193C7.8722 39.7191 10.0174 39.7191 14.3079 39.7191H37.0613C41.3518 39.7191 43.497 39.7191 44.8298 38.5193C46.1627 37.3195 46.1627 35.3884 46.1627 31.5263V21.2853C46.1627 15.4921 46.1627 12.5955 44.1634 10.7958C42.1641 8.99609 38.9463 8.99609 32.5106 8.99609H18.8585C12.4229 8.99609 9.20507 8.99609 7.20577 10.7958ZM17.152 33.5745C17.152 32.7261 17.9161 32.0383 18.8585 32.0383H32.5106C33.4531 32.0383 34.2171 32.7261 34.2171 33.5745C34.2171 34.4229 33.4531 35.1106 32.5106 35.1106H18.8585C17.9161 35.1106 17.152 34.4229 17.152 33.5745Z",
    fill: "url(#paint1_linear_318_1668)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_318_1668",
    x: 0,
    y: -1,
    width: 54,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.65
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.9 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_318_1668"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_318_1668",
    x1: 3.43619,
    y1: 14.2541,
    x2: 54.425,
    y2: 24.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_318_1668",
    x1: 3.43619,
    y1: 14.2541,
    x2: 54.425,
    y2: 24.9244,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BBFFE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.521875,
    stopColor: "#8629FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FC4AF5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptopIcon);
export default __webpack_public_path__ + "static/media/laptop-icon.89d8bf2af43561a2bc00d4575da062e1.svg";
export { ForwardRef as ReactComponent };